Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.PriorityQueue = (function() {
  function PriorityQueue() {

    Monet.UI.Fields.Base.apply(this, arguments);

    this.createBaseStructure();

    this.input = null;

    this.finished = false;

    this.valuObj = null;

    this.setFieldId = function(id) {
      this.fieldId = id;
    };

    this.setValue = function (valueObj) {

      let priorityObjectives = this.input.children;
      priorityObjectives = Array.prototype.slice.call(priorityObjectives, 0);

      valueObj = valueObj || this.valueObj;
      priorityObjectives.sort( (a, b) =>
        valueObj.indexOf(a.children[1].id) - valueObj.indexOf(b.children[1].id)
      );

      if(priorityObjectives.length > 0) {
        this.input.innerHTML = '';
        for(let i = 0; i < priorityObjectives.length; i++) {
          priorityObjectives[i].children[0].children[0].innerHTML = i+1;
          this.input.appendChild(priorityObjectives[i]);
        }
      }
      this.finished = true;
      this.valueObj = valueObj;
   };

    this.getValue = function() {

      let priorityArray = [];
      const childDivs = this.input.getElementsByTagName('div');
      for( let i = 0; i < childDivs.length; i++ ) {
        if(childDivs[i].className === "contentContainer"){
          const index = Math.floor(i/4);
          priorityArray.push(childDivs[i].id);
        }
      }
      return priorityArray;
    };

    this.createElement = function() {

      this.input = document.createElement("div");
      this.input.className = "priorityQueueContainer";

      window.Dragula([this.input]).on('drop', function (el, target, source, sibling) {
        let count = 0;
        const dragulaContainer = el.parentElement;
        const childDivs = dragulaContainer.getElementsByTagName('div');
        for( let i = 0; i < childDivs.length; i++ ) {
          if(childDivs[i].className === "circleContainer"){
            count++;
            childDivs[i].innerHTML = `${count}`;
          }
        }
      }.bind(this));

      this.rootEl.appendChild(this.input);
    };

    this.checkPriorityQueueTypeAndRequestData = function(callback) {
      this.requestFieldDomain(callback);
    };

    this.requestFieldDomain = function(callback) {
      if (!this.fieldId) {
        return;
      }

      var request = new Monet.Ajax();

      request.url = "Field/" + this.fieldId + "/FindDomains";
      request.success = function(data) {
        callback(data);
      };

      request.send();
    };

    this.successOfRequestData = (function(scope) {
      return function(data) {
        scope.priorityArray = data;
        scope.renderItemsList(data);
      };
    })(this);

    this.renderItemsList = (function(scope) {

      return function(data) {

          for (var i = 0; i < data.length; i++) {
            const priorityItem = document.createElement('div');

            const queueNumberDiv = document.createElement('div');
            queueNumberDiv.className = "numberContainer"
            const circleDiv = document.createElement('div');
            circleDiv.className = "circleContainer";
            circleDiv.appendChild(document.createTextNode(i + 1));
            queueNumberDiv.appendChild(circleDiv);

            const contentDiv = document.createElement('div');
            contentDiv.className = "contentContainer"
            contentDiv.id = data[i].value;

            contentDiv.appendChild(document.createTextNode(Monet.I18n.getResourcesByKey(data[i].description)));

            priorityItem.appendChild(queueNumberDiv);
            priorityItem.appendChild(contentDiv);
            priorityItem.className = "priorityItem";

            scope.input.appendChild (priorityItem);
          }

          if(this.finished) {
            this.setValue(this.valuObj);
          }
      };
    })(this);

    this.render = function() {
      this.createElement();
      this.checkPriorityQueueTypeAndRequestData(this.successOfRequestData);
      return this.rootEl;
    };
  }

  return PriorityQueue;
})();
